const CopyPathIcon = ({ size = 20 }: { size?: number }) => {
  return (
    <svg height={size} viewBox='0 0 20 20' width={size} xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M 2.5 11.3 H 1.3 V 2.5 C 1.3 1.8 1.8 1.3 2.5 1.3 H 11.3 V 2.5 H 2.5 V 11.3 Z M 17.5 6.3 V 17.5 H 6.3 V 6.3 H 17.5 Z M 6.3 5 H 17.5 C 18.2 5 18.8 5.6 18.8 6.3 V 17.5 C 18.8 18.2 18.2 18.8 17.5 18.8 H 6.3 C 5.6 18.8 5 18.2 5 17.5 V 6.3 C 5 5.6 5.6 5 6.3 5 Z M 15 14 C 15 13.4 14.6 13 14 13 H 10.3 C 9 13 8 12 8 10.8 C 8 9.5 9 8.5 10.3 8.5 H 14.2 L 12.8 7.7 L 13.3 6.8 L 16.3 8.6 C 16.4 8.7 16.5 8.8 16.5 9 C 16.5 9.2 16.4 9.3 16.3 9.4 L 13.3 11.2 L 12.8 10.3 L 14.2 9.5 H 10.3 C 9.6 9.5 9 10.1 9 10.8 C 9 11.4 9.6 12 10.3 12 H 14 C 15.1 12 16 12.9 16 14 C 16 15.1 15.1 16 14 16 H 8 V 15 H 14 C 14.6 15 15 14.6 15 14 Z'
        fillRule='evenodd'
      />
    </svg>
  );
};

export default CopyPathIcon;
